/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OktoberfestLayers, Layers} from "../view/OktoberfestLayers";
import {Oktoberfest} from "../Oktoberfest";
import {Translation} from "../../core/utils/Translation";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {MultiStyleText} from "../../core/utils/MultiStyleText";
import {Elastic, TweenLite, TimelineLite, Expo, Power3} from "gsap";
import {EasePack} from "gsap/dist/EasePack";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import EaseFunction = gsap.EaseFunction;
import Container = PIXI.Container;
import {OktoberfestReelView} from "../reels/OktoberfestReelView";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {MathHelper} from "../../core/utils/MathHelper";
import {GameHelper} from "../../core/utils/GameHelper";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {Helper} from "@nolimitcity/slot-launcher/bin/utils/Helper";


export class FreespinIntro extends ContinueScreen {
    private static FS_INTRO_ARROW: string = "fsIntroArrow";
    private static TEXT_YOU_WIN: string = "You won";
    private static TEXT_BEER_SPINS: string = "bier spins";
    private static FS_INTRO_HEAD: string = "Collect Scatters";
    private static FS_INTRO_TEXT1: string = "Each scatter fills the";
    private static FS_INTRO_TEXT2: string = " beer-meter";
    private static FS_INTRO_TEXT3: string = ", giving you additional spins and increased multiplier.";
    private static SCATTER_SYMBOL_POSITIONS: PIXI.Point[] = [new PIXI.Point(0, 64), new PIXI.Point(0, 249), new PIXI.Point(0, 424)];
    private _background: PIXI.Container;
    private _banner: PIXI.Container;
    private _bannerHeight = 75;
    private _backgroundAlphaSetting: number = 1;
    private _informationContainer: Container;
    private _mobileOffsetRatio: number;
    private _youWonText: PIXI.Text;
    private _freeSpinsText: PIXI.Text;
    private _freespinNumberAnimation: TimelineSprite;
    private _timeLine: TimelineLite;
    private _informationText: MultiStyleText;
    private _informationHead: PIXI.Text;
    private _scatterArrow: PIXI.Sprite;
    private _meterArrow: PIXI.Sprite;
    private _scatterSymbol: PIXI.Sprite;
    private _previousYouWonTextX: number;
    private _flyingTextContainer: PIXI.Container;
    private _informationTextStyle: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontSize: "23px",
        fill: "#FFFFFF"
    };
    private _informationTextStyleBold: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontSize: "23px",
        fill: "#FFFFFF",
        fontWeight: "800"
    };
    private _flyingTextStyle: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: 100,
        fill: "#C3BE5A",
        stroke: "#1B1A15",
        strokeThickness: 2,
        dropShadow: true,
        dropShadowColor: "#1B1A15",
        dropShadowAngle: 0.872665, //PhotoShop 120 real 50
        dropShadowDistance: 5,
        padding: 20
    };
    private _informationHeadStyle: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: "46.2px",
        fill: "#C3BE5A",
        stroke: "#1B1A15",
        strokeThickness: 2,
        dropShadow: true,
        dropShadowColor: "#1B1A15",
        dropShadowAngle: 0.872665,
        dropShadowDistance: 5,
        padding: 20
    };

    constructor() {
        super(OktoberfestLayers.getLayer(Layers.SCREENS)!);
        this.initAnimations();
    }


    public show(onContinueCallBack: () => void): void {
        this.setScatterPosition();
        this.hideInformationContainer();
        GameHelper.dimSymbols();
        const fsLeft = Oktoberfest.model.isRestore ? Oktoberfest.model.parsedInitData.freespinsLeft : Oktoberfest.model.parsedGameData.freespinsLeft;
        new TweenLite({}, 0.5, {
            onComplete: () => {
                this.playWinFreeSpinAnimation();
            }
        });
        Oktoberfest.betlines.enableBetlineNumber(false);
        Oktoberfest.betlines.onHideAllBetLines();
        super.show(onContinueCallBack);
        this._continueButton.visible = false;
        this._continueButton.enable(false);
    }

    public onResize(): void {
        if(this._background.children.length>0) {
            let graphics = this._background.getChildAt(0) as PIXI.Graphics;
            graphics.clear();
            graphics.beginFill(0x000000, 0.4);
            graphics.drawRect(0, -4,
                NolimitApplication.screenBounds.width,
                NolimitApplication.screenBounds.height);
            graphics.endFill();
            this._background.pivot = new PIXI.Point(graphics.width * 0.5, graphics.height * 0.5);
            this._banner.children.forEach((eachChild:any)=>{
                (eachChild).width = NolimitApplication.screenBounds.width;
            });
            this._banner.pivot = new PIXI.Point(NolimitApplication.screenBounds.width * 0.5, this._bannerHeight * 0.5);
        }
        if(Oktoberfest.model.isRestore){
            if(Oktoberfest.model.parsedInitData.freespinsLeft>-1){
                this.setScatterPosition();
            }
            }
        }


    public onOrientationChanged(): void {
        if(!(NolimitApplication.isLandscape)){
            this._mobileOffsetRatio = 0.4;
            const centerBottom = ( NolimitApplication.screenBounds.bottom - 610 ) * 0.5 + 510;
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom);
        }else{
            if(!(Helper.isDefaultScreenRatio(NolimitApplication.screenBounds))){
                this._mobileOffsetRatio = 1;
            }else {
                this._mobileOffsetRatio = 0.6;
            }
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, 595);
        }
        if(!Oktoberfest.model.isRestore){
            if(Oktoberfest.model.parsedInitData.freespinsLeft>-1) {
               this.setScatterPosition();
            }
        }
    }

    public setScatterPosition(): void {
        let symbolIndex: number = 0;
        if (Oktoberfest.model.isRestore && Oktoberfest.model.parsedInitData.scatterPositions!) {
            symbolIndex = Oktoberfest.model.parsedInitData.scatterPositions![0];
        } else if(Oktoberfest.model.parsedGameData){
            symbolIndex = Oktoberfest.model.parsedGameData.scatterPositions![0];
        }else{
            return
        }
        // symbolIndex;

        if (symbolIndex == 0) {
            this._scatterArrow.rotation = MathHelper.degToRad(-150);
            this._scatterArrow.position.y = 120;
        } else if (symbolIndex == 1) {
            this._scatterArrow.rotation = MathHelper.degToRad(-200);
            this._scatterArrow.position.y = 200;
        } else if (symbolIndex == 2) {
            this._scatterArrow.rotation = MathHelper.degToRad(-240);
            this._scatterArrow.position.y = 290;
        }else{
            return;
        }

        const scale: number = NolimitApplication.screenBounds.scale;
        this._scatterSymbol.position.x = OktoberfestReelView.REEL_AREAS[0].x + ( FreespinIntro.SCATTER_SYMBOL_POSITIONS[symbolIndex].x);
        this._scatterSymbol.position.y = OktoberfestReelView.REEL_AREAS[0].y + ( FreespinIntro.SCATTER_SYMBOL_POSITIONS[symbolIndex].y );
        if (GameHelper.isDesktop()) {
            this._scatterSymbol.position.x += ( -OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET * scale ) - 40;
        } else {
            if(!NolimitApplication.isLandscape) {
                this._scatterSymbol.position.x = 87;
                this._scatterSymbol.position.y = this._scatterSymbol.position.y;
            }
        }
    }

    public initialiseFreeSpin(): void {
        if (Oktoberfest.model.isRestore) {
            OktoberfestLayers.getLayer(Layers.BETLINES)!.visible = false;
            if (NolimitApplication.isLandscape) {
                if(GameHelper.isDesktop()) {
                    const bgOffset: number = -OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET;
                    Oktoberfest.reelDividers.setDesktopPos(bgOffset);
                    OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS)!.x = bgOffset;
                    OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS)!.x = bgOffset;
                    OktoberfestLayers.getLayer(Layers.LOW_SYMBOLS_WIN)!.x = bgOffset;
                    OktoberfestLayers.getLayer(Layers.HIGH_SYMBOLS_WIN)!.x = bgOffset;
                    OktoberfestLayers.getLayer(Layers.REEL_ATTENTION)!.x = bgOffset;
                    OktoberfestLayers.getLayer(Layers.BETLINES)!.visible = false;
                }
                Oktoberfest.leftIndicator.onRestoreInFS();
                if(Helper.isDefaultScreenRatio(NolimitApplication.screenBounds)){
                    Oktoberfest.foreground.showLogoStaticInFS();
                }
            }
        }
        Oktoberfest.scatterMeter.onAddToStage({
            playIntro: false
        });
        Oktoberfest.fsMultiplier.onAddToStage({
            playIntro: false
        });
        Oktoberfest.background.onFreespinIntroViewClosed();
        Oktoberfest.leftIndicator.onFreespinIntroViewClosed();
        Oktoberfest.foreground.onFreespinIntroPanningComplete();
        Oktoberfest.foreground.playLogoFSAnimation();
        Oktoberfest.foreground.setLogoGoldenFrame();
        if (Oktoberfest.model.parsedGameData) {
            if (Oktoberfest.model.parsedGameData.mode === GameMode.FREESPIN || Oktoberfest.model.parsedGameData.nextMode === GameMode.FREESPIN) {
                Oktoberfest.foreground.showLogoStaticInFS();
            }
        }
    }

    protected close(): TimelineLite {
        this.initialiseFreeSpin();
        OktoberfestSound.switchMusic(
            {
                name: OktoberfestSound.FREESPIN,
                volume: 1
            },
            undefined,
            {name: OktoberfestSound.LOOP_NAME_BAR_AMBIENCE, to: 0, duration: 500}
        );
        return super.close();
    }

    private initAnimations(): void {

        this._background = this.createBackground();
        this._container.addChild(this._background);
        this._container.position.set(360, 360);

        this._banner = this.createBanner();
        this._container.addChild(this._banner);

        this._flyingTextContainer = this.createFlyingText();
        this._container.addChild(this._flyingTextContainer);

        this._informationContainer = this.createTextsAndArrows();
        this._container.addChild(this._informationContainer);
        if(GameHelper.isDesktop()) {
            (Oktoberfest.model.parsedInitData.isRestoreState)
            {
                Oktoberfest.foreground.desktopDefaultForegroundSetting();
            }
        }
        this.createWinFreeSpinTimeLine();
        this._scatterSymbol = this.createScatterSymbol();
        this.addChild(this._scatterSymbol);
        this.createFreeSpinNumberAnimation();
        this.onResize();
        this.onOrientationChanged();
    }

    private createFlyingText(): PIXI.Container {
        let flyingTextContainer: PIXI.Container = new PIXI.Container();

        flyingTextContainer.visible = false;
        this._youWonText = new PIXI.Text(`${Translation.translation(FreespinIntro.TEXT_YOU_WIN)}`, this._flyingTextStyle);
        this._youWonText.anchor.set(0.5, 0.5);
        this._youWonText.position.set(-((NolimitApplication.screenBounds.width) / 2 -( this._youWonText.width)* this._mobileOffsetRatio ) , -140);


        this._freeSpinsText = new PIXI.Text(`${Translation.translation(FreespinIntro.TEXT_BEER_SPINS)}`, this._flyingTextStyle);
        this._freeSpinsText.anchor.set(0.5, 0.5);
        this._freeSpinsText.position.set(((NolimitApplication.screenBounds.width) / 2 - (( this._freeSpinsText.width )* this._mobileOffsetRatio)), 140);
        if(this._freeSpinsText.width>=0.6*(NolimitApplication.screenBounds.width)||this._youWonText.width>=0.6*(NolimitApplication.screenBounds.width))
        {
            this._youWonText.style.fontSize=this._youWonText.style.fontSize*0.73;
            this._freeSpinsText.style.fontSize=this._freeSpinsText.style.fontSize*0.73;
            this._freeSpinsText.position.set(((NolimitApplication.screenBounds.width) / 2 - (( this._freeSpinsText.width )* this._mobileOffsetRatio)) , 140);

        }

        flyingTextContainer.addChild(this._youWonText);
        flyingTextContainer.addChild(this._freeSpinsText);

        return flyingTextContainer;
    }

    private createBanner(): PIXI.Container {
        let banner: PIXI.Container = new PIXI.Container();
        let plate: PIXI.Graphics = new PIXI.Graphics();
        plate.beginFill(0x124467, 1);
        plate.drawRect(0, 0, NolimitApplication.screenBounds.width, this._bannerHeight);
        plate.endFill();
        banner.addChild(plate);

        banner.pivot = new PIXI.Point(plate.width * 0.5, plate.height * 0.5);
        banner.scale.y = 0;

        let lineTL: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("partyModeGoldBorder")[0]);
        lineTL.anchor.set(0, 1);
        lineTL.position.set(0, 0);
        lineTL.width =  NolimitApplication.screenBounds.width;
        banner.addChild(lineTL);

        let lineBL: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("partyModeGoldBorder")[0]);
        lineBL.anchor.set(0, 0);
        lineBL.position.set(0, plate.height);
        lineTL.width =  NolimitApplication.screenBounds.width;
        banner.addChild(lineBL);

        return banner;
    }

    private createTextsAndArrows(): PIXI.Container {
        let informationContainer: PIXI.Container = new PIXI.Container();
        let textFieldWidth: number = 350;
        let meterPosition: PIXI.Point = new PIXI.Point(370, 214);
        this._informationHead = new PIXI.Text(`${Translation.translation(FreespinIntro.FS_INTRO_HEAD)}`, this._informationHeadStyle);
        this._informationHead.position.set(30,50);
        if(!NolimitApplication.isLandscape){
            this._informationHead.position.set(30,50);
        }
        this._informationHead.anchor.set(0, 0);
        this._informationHead.alpha = 0;
        informationContainer.x = -informationContainer.width / 2 - 195;
        informationContainer.y = -informationContainer.height / 2 - 250;

        informationContainer.addChild(this._informationHead);

        this._informationText = new MultiStyleText({
            texts: [
                {
                    text: Translation.translation(FreespinIntro.FS_INTRO_TEXT1),
                    style: this._informationTextStyle
                },
                {
                    text: " " + Translation.translation(FreespinIntro.FS_INTRO_TEXT2),
                    style: this._informationTextStyleBold
                },
                {
                    text: Translation.translation(FreespinIntro.FS_INTRO_TEXT3),
                    style: this._informationTextStyle
                }
            ],
            wordWrap: true,
            wordWrapWidth: textFieldWidth
        });
        this._informationText.alpha = 0;
        this._informationText.y = 85;
        this._informationText.position.set(30,120);
        if(!NolimitApplication.isLandscape){
            this._informationText.position.set(30,120);
        }
        informationContainer.addChild(this._informationText);

        this._scatterArrow = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures(FreespinIntro.FS_INTRO_ARROW)[0]);
        this._scatterArrow.anchor.set(0.5, 0.5);
        this._scatterArrow.alpha = 0;
        this._scatterArrow.position.x = -60;
        informationContainer.addChild(this._scatterArrow);

        this._meterArrow = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures(FreespinIntro.FS_INTRO_ARROW)[0]);
        this._meterArrow.anchor.set(0.5, 0.5);
        this._meterArrow.alpha = 0;
        this._meterArrow.scale.set(1, -1);
        this._meterArrow.rotation = ( Math.PI / 180 ) * 20;

        this._meterArrow.position.set(meterPosition.x, meterPosition.y+40);
        informationContainer.addChild(this._meterArrow);

        if (!GameHelper.isDesktop()) {
            this._scatterArrow.visible = false;
            this._meterArrow.visible = false;
        }
        return informationContainer
    }

    private createBackground(): PIXI.Container {
        const graphics: PIXI.Graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 0.4);
        graphics.drawRect(0, -4, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
        graphics.endFill();
        const background: PIXI.Container = new PIXI.Container;
        background.alpha = 0;
        background.addChild(graphics);
        background.pivot = new PIXI.Point(graphics.width * 0.5, graphics.height * 0.5);
        return background;
    }

    private playWinFreeSpinAnimation(): void {
        OktoberfestLayers.getLayer(Layers.WIN_COUNT_UP!)!.visible = false;
        Oktoberfest.background.fadeWinOverlay(0.01);
        this.hideInformationContainer();
        this._previousYouWonTextX = this._youWonText.x;

        //freezeGame.addBlur(OktoberfestLayers.getLayer(Layers.FOREGROUND)!, 0.001);
        this._timeLine.play(0);
        //Oktoberfest.foreground.hideLogo();
    }

    private showContinueBtn(): void {
        this._continueButton.visible = true;
        this._continueButton.enable(true);
        Oktoberfest.reelDividers.setDesktopPos(-OktoberfestGameConfig.FREESPIN_INTRO_BACKGROUND_OFFSET);
    }

    private createWinFreeSpinTimeLine(): void {
        this._timeLine = new TimelineLite({paused: true, onComplete: () => this.showContinueBtn()});
        let defaultEase: EaseFunction = Power3.easeIn;
        let slowMoEase: EaseFunction = EasePack.SlowMo.config(0.85, 0.92);

        //background in
        this._timeLine.add([
            () => {
                OktoberfestSound.soundPlayer.playTrack({
                    name: OktoberfestSound.SOUND_NAME_FS_WIN_BANNER
                });
            }
        ]);

        //#739
        //background in
        /*this._timeLine.add([

            new TweenLite(this._background, 0.5, {alpha: this._backgroundAlphaSetting, ease: defaultEase}),

        ]);*/

        this._timeLine.add([() => {
            OktoberfestSound.switchMusic(
                {
                    name: OktoberfestSound.LOOP_NAME_BAR_AMBIENCE,
                    volume: 1
                },
                undefined,
                {name: OktoberfestSound.MAIN_GAME_MUSIC, to: 0, duration: 500}
            );
        }], 0.5);

        //banner in
        this._timeLine.add([

            new TweenLite(this._banner.scale, 0.13, {y: 1, ease: defaultEase})
        ], "+=0.1");
        //console.log(this._freeSpinsText.width,"freeSpinsTextWidth");
        //Flying text
        this._timeLine.add([
            () => this.playFreeSpinNumberAnimation(),
            () => this.showFlyingTextContainer(),
            new TweenLite(this._youWonText, 2.0, {
                onUpdate: () => this.onFlyingTextUpdate(),
                onComplete: () => this.onFlyingTextComplete(),
                x: ( NolimitApplication.screenBounds.width / 2 ) - (( this._youWonText.width ) * this._mobileOffsetRatio),
                ease: slowMoEase
            }),
            new TweenLite(this._freeSpinsText, 2.0, {
                 x: -( NolimitApplication.screenBounds.width / 2 ) + (( this._freeSpinsText.width ) * this._mobileOffsetRatio),
                ease: slowMoEase
            })
        ]);

        //banner out
        this._timeLine.add(new TweenLite(this._banner.scale, 0.13, {y: 0, ease: defaultEase}));

        // //background out
        this._timeLine.add(new TweenLite(this._background, 0.5, {alpha: 0, ease: defaultEase}));

        //Panning only on Desktop
        if (NolimitApplication.isLandscape) {
            let scatterFadeInTime: number = 2;
            this._timeLine.add(() => this.playStagePanning(OktoberfestGameConfig.TIMING_FREESPIN_INTRO_PANNING_DURATION));
            this._timeLine.add(() => this.onPanningComplete(), this._timeLine.totalDuration() + scatterFadeInTime);
        } else if (Oktoberfest.model.parsedGameData) {
            if (Oktoberfest.model.parsedGameData.mode === GameMode.FREESPIN || Oktoberfest.model.parsedGameData.nextMode === GameMode.FREESPIN) {

            }
        }
        //background in
        this._timeLine.add(new TweenLite(this._background, 0.5, {
            alpha: this._backgroundAlphaSetting,
            ease: defaultEase
        }));

        //Fade in text + arrow + scatter
        this._timeLine.add([
            () => {

                //freezeGame.addBlur(OktoberfestLayers.getLayer(Layers.FOREGROUND)!, 0.001);
                OktoberfestSound.soundPlayer.playTrack({
                    name: OktoberfestSound.SOUND_NAME_FS_SCATTER_INFO_TEXT
                });
                this.scaleIntroScatter();
            },
            //() => EventHandler.dispatchEvent(new GameEvent(SoundEvent.PLAY_SOUND_EFFECT, OktoberfestSound.SOUND_NAME_FS_SCATTER_INFO_TEXT)),
            new TweenLite(this._informationHead, 1, {alpha: 1, ease: defaultEase}),
            new TweenLite(this._informationText, 1, {alpha: 1, ease: defaultEase}),
            new TweenLite(this._scatterArrow, 0.5, {alpha: 1, ease: defaultEase}),
            new TweenLite(this._scatterSymbol, 0.5, {alpha: 1, ease: defaultEase})
        ]);
        //start fs meter animation + arrow
        this._timeLine.add(new TweenLite(this._meterArrow, 0.5, {alpha: 1, ease: defaultEase}));
        this._timeLine.add(() => this.startScatterMeterIntroAnimation());
        this._timeLine.add(() => this.startMultiplierIntroAnimation(), "+=0.5");
    }

    private hideInformationContainer(): void {
        this._informationHead.alpha = 0;
        this._informationText.alpha = 0;
        this._scatterArrow.alpha = 0;
        this._meterArrow.alpha = 0;
        this._scatterSymbol.alpha = 0;
    }

    private startScatterMeterIntroAnimation(): void {
        this._timeLine.pause();
        Oktoberfest.scatterMeter.onAddToStage({
            playIntro: true,
            completeCallback: () => this.onScatterMeterIntroComplete()
        });
    }

    private startMultiplierIntroAnimation(): void {
        this._timeLine.pause();
        Oktoberfest.fsMultiplier.onAddToStage({
            playIntro: true,
            completeCallback: () => this.onMultiplierIntroComplete()
        });
    }

    private onScatterMeterIntroComplete(): void {
        this._timeLine.play();
    }

    private onMultiplierIntroComplete(): void {
        this._timeLine.play();
    }

    private scaleIntroScatter(): TweenLite {
        this._scatterSymbol.alpha = 1;
        let scale: number = 1;
        return new TweenLite(this._scatterSymbol.scale, ( 0.9 * scale ), {
            x: ( 1.15 * scale ),
            y: ( 1.15 * scale ),
            ease: Elastic.easeOut.config(1.75, 1),
            delay: 0.4
        })
    }

    private playFreeSpinNumberAnimation(): void {
        this._freespinNumberAnimation.visible = true;
        this._freespinNumberAnimation.getAnimation([0], () => {
        }, () => {
            this.onFreeSpinNumberAnimationComplete();
        });
    }

    private createScatterSymbol(): PIXI.Sprite {
        let scatterSymbol: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("S")[0]);
        scatterSymbol.anchor.set(0.5, 0.5);
        scatterSymbol.alpha = 0;
        const symbol = Oktoberfest.reels[0].getSymbol(2);
        scatterSymbol.x = symbol.x - symbol.width / 2;
        scatterSymbol.y = symbol.y - symbol.height / 2;
        return scatterSymbol;
    }

    private createFreeSpinNumberAnimation(): void {
        this._freespinNumberAnimation = new TimelineSprite(Oktoberfest.assetLoader.getTextures("freespinIntroFreespinWinNumber"));
        this._freespinNumberAnimation.anchor.set(0.5, 0.5);
        this._freespinNumberAnimation.visible = false;
        this._container.addChild(this._freespinNumberAnimation);
    }

    private onFreeSpinNumberAnimationComplete(): void {
        this._freespinNumberAnimation.visible = false;
    }

    private onFlyingTextComplete(): void {
        this._flyingTextContainer.visible = false;
    }

    private showFlyingTextContainer(): void {
        this._flyingTextContainer.visible = true;
    }

    //Only on desktop
    private playStagePanning(duration: number): void {
        const tl: TimelineLite = new TimelineLite();
        if (duration > 0.1) {
            //freezeGame.onFreespinIntroPanning(duration);
            Oktoberfest.foreground.logoPanning();
            Oktoberfest.background.onFreespinIntroPanning(duration);
            Oktoberfest.leftIndicator.onBeerGlassIntroPanning(duration);
            if(GameHelper.isDesktop()) {
                Oktoberfest.reelDividers.onFreeSpinIntroPanning(duration);
            }
        }
        tl.add([
            () => {
                Oktoberfest.foreground.onFreespinIntroPanning(duration);
            }
        ], duration);
    }

    private onPanningComplete(): void {

    }

    private onFlyingTextUpdate(): void {
        let vel: number = Math.floor(this._youWonText.x - this._previousYouWonTextX);
        let scale: number = MathHelper.map(vel, 0, 600 * this._timeLine.timeScale(), 1, 0.05);

        this._youWonText.scale.y = scale;
        this._freeSpinsText.scale.y = scale;
        this._previousYouWonTextX = this._youWonText.x;
    }
}